export default __webpack_public_path__ + "static/media/s008.c1668e6f.jpeg";